function safariFix() {
    var olElement = document.querySelector('.accessible-megamenu ol');

    if (olElement) {
        olElement.style.display = 'flex';
        olElement.style.justifyContent = 'flex-end';
    }
}

export default safariFix;